<template>
    <modal ref="previewModal"
           :show="ceremonyPreview"
           @close="closeModal()"
           :custom_modal_class="'preview-modal' + (fullscreen ? ' fullscreen-preview' : '')"
           :custom_dialog_css="'padding-bottom: 130px'"
           :custom_body_css="''"
           :custom_footer_class="'d-none d-md-flex'"
    >

        <div slot="header">
            <div class="modal-header">
                <h5 class="modal-title">{{ $t('preview.title') }}</h5>

                <button type="button"
                        class="close"
                        @click="fullscreen = !fullscreen"
                        :v-tooltip="$t(fullscreen ? 'preview.normal_view' : 'preview.fullscreen_view')"
                >
                    <span aria-hidden="true">
                        <icon :name="fullscreen ? 'compress' : 'expand'"/>
                    </span>
                </button>

                <button type="button"
                        class="close ml-2"
                        data-dismiss="modal"
                        aria-label="Close"
                        @click="closeModal()"
                >
                    <span aria-hidden="true">×</span>
                </button>
            </div>
        </div>

        <div slot="body" class="preview-modal-body">
            <div class="row">
                <div class="col-12 col-lg-6 preview-embed h-100 position-sticky" style="top: 20px;">
                    <div class="h-100" style="padding-bottom: 50px">
                        <div :class="'embed-responsive embed-responsive-' + aspectRatio" style="max-height: 100%">
                            <player-v1 :communication="PLAYER_COMMUNICATION.INLINE" v-if="ceremonyPreview && playerVersion === 1" class="embed-responsive-item"/>
                            <player-v2 :communication="PLAYER_COMMUNICATION.INLINE" v-if="ceremonyPreview && playerVersion === 2" class="embed-responsive-item"/>
                        </div>
                    </div>
                </div>

                <div class="col-12 col-lg-6 preview-blocks">
                    <ceremony-controller
                        :with-status="true"
                        v-if="ceremonyPreview"
                        :ceremony_id="ceremonyPreview.code"
                        :communication="PLAYER_COMMUNICATION.INLINE"
                    ></ceremony-controller>
                </div>
            </div>
        </div>

        <div slot="footer">
            <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" @click="closeModal">
                {{ $t('general.close') }}
            </button>
        </div>
    </modal>
</template>

<script>
    import Modal from '../../components/Modal';
    import CeremonyController from '../../controller/components/CeremonyController';
    import {mapState} from 'vuex';
    import { PLAYER_COMMUNICATION } from '../../enums/player-communication';
    import PlayerV1 from '../../player/components/Player';
    import PlayerV2 from '../../player-v2/components/Player';

    export default {

        components: {
            PlayerV1,
            PlayerV2,
            CeremonyController,
            Modal
        },

        computed: {
            PLAYER_COMMUNICATION() {
                return PLAYER_COMMUNICATION
            },
            ...mapState({
                ceremonyPreview: state => state.ceremonyPreview
            }),

            playerVersion() {
                return this.ceremonyPreview?.location?.player_version || 1;
            },

            aspectRatio() {
                return this.ceremonyPreview?.location?.aspect_ratio || '4by3';
            }
        },

        data() {
            return {
                fullscreen: false
            };
        },

        methods: {
            closeModal() {
                this.$store.commit('showCeremonyPreview', null);
            }
        }
    };
</script>

<style lang="scss">

    .preview-modal {
        max-width: calc(100% - 60px);

        @media(min-width: 1280px) {
            max-width: 1200px;
        }

        @media(max-width: 992px) {
            max-width: none;

            height: 100%;
            padding-bottom: 15px !important;

            .preview-modal-body {
                max-height: 100%;
                display: flex;
                align-items: stretch;
                width: 100%;
                overflow: hidden;
                height: 100%;

                > .row {
                    align-content: stretch;
                    max-height: 100%;
                    display: flex;
                    align-items: stretch;
                    width: 100%;
                    margin: 0;

                    .preview-embed {
                        flex: 1 1 auto;
                        max-height: 30%;
                        overflow: hidden;
                    }

                    .preview-blocks {
                        flex: 1 1 auto;
                        //display: flex;
                        overflow-y: auto;
                        padding-top: 15px;
                        max-height: 70%;
                    }
                }
            }

            .embed-responsive {
                max-height: 30vh;
            }

            .modal-content {
                height: 100%;

                .modal-body {
                    overflow-y: auto;
                }
            }
        }
    }

</style>
